<template>
  <v-card class="com-pc-card tm-pc-obs-list-card" obs-list-type="obs-list">
    <v-col class="com-pc-card-contents">
      <v-row v-if="showRsys" class="ma-0 pl-2 tm-no-show">
        <span>
          地図を拡大してください。
        </span>
      </v-row>
      <!-- 読み込み中 -->
      <div
        class="tmList-progress"
        v-show="this.reqParam.townsAcqTime != this.tmListDatasParam.rsysAcqTime"
      >
        <v-progress-circular
          indeterminate
          :size="30"
          :width="5"
        ></v-progress-circular>
      </div>
      <!-- 表示 -->
      <div
        v-if="
          !showRsys &&
            !isEmpty(rsysList) &&
            !rsysFullOpenReadyFlg &&
            this.reqParam.townsAcqTime == this.tmListDatasParam.rsysAcqTime
        "
      >
        <v-list>
          <v-list-group
            no-action
            v-for="rsysItem in rsysList"
            :key="rsysItem.rsysCd"
            :value="rsysFullOpenEndFlg"
          >
            <template v-slot:activator>
              <!-- <v-list-item-icon>
                <v-icon
                  v-if="rsysItem.maxOvLvl"
                  class="tm-pc-info-color"
                  :rw-info-color="setRwInfoColor(rsysItem.maxOvLvl)"
                  >warning</v-icon
                >
              </v-list-item-icon> -->
              <v-list-item-content>
                <!-- <v-list-item-title>{{ rsysItem.rsysNm }}水系</v-list-item-title> -->
                  <v-list-item-title>
                <span>
                {{ rsysItem.rsysNm }}水系
                </span>
                <span v-if="rsysItem.showStg === 1">
                  <v-chip
                    v-show="showOvlvlLabel(rsysItem.stgOvlvl)"
                    class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                    :rw-info-color="setRwInfoColor(rsysItem.stgOvlvl)"
                    label
                    x-small
                    >{{ getStgOvlvlNm(rsysItem.stgOvlvl) }}</v-chip
                  >
                </span>
                <span v-else-if="rsysItem.showStg === 2">
                  <v-chip
                    v-show="showSwStgOvlvlLabel(rsysItem.swStgOvlvl)"
                    class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                    :rw-info-color="setRwInfoColor(rsysItem.swStgOvlvl)"
                    label
                    x-small
                    >{{ getSwStgOvlvlNm(rsysItem.swStgOvlvl) }}</v-chip
                  >
                </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list v-if="reload">
              <v-list-group
                sub-group
                v-for="rvrItem in rsysItem.rvrInfo"
                @click="getTmRvrListDatas(rsysItem.rsysCd, rvrItem.rvrCd)"
                :key="rvrItem.rvrCd"
                :value="rsysFullOpenEndFlg"
                no-action
              >
                <template v-slot:activator>
                  <!-- <v-list-item-icon>
                    <v-icon
                      v-if="rvrItem.maxOvLvl"
                      class="tm-pc-info-color"
                      :rw-info-color="setRwInfoColor(rvrItem.maxOvLvl)"
                      >warning</v-icon
                    >
                  </v-list-item-icon> -->
                  <v-list-item-content no-action class="pl-2">
                    <!-- <v-list-item-title v-text="rvrItem.rvrNm">
                    </v-list-item-title> -->
              <v-list-item-title>
                <span>
                  {{rvrItem.rvrNm}}
                </span>
                <span v-if="rvrItem.showStg === 1">
                  <v-chip
                    v-show="showOvlvlLabel(rvrItem.stgOvlvl)"
                    class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                    :rw-info-color="setRwInfoColor(rvrItem.stgOvlvl)"
                    label
                    x-small
                    >{{ getStgOvlvlNm(rvrItem.stgOvlvl) }}</v-chip
                  >
                </span>
                <span v-else-if="rvrItem.showStg === 2">
                  <v-chip
                    v-show="showSwStgOvlvlLabel(rvrItem.swStgOvlvl)"
                    class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                    :rw-info-color="setRwInfoColor(rvrItem.swStgOvlvl)"
                    label
                    x-small
                    >{{ getSwStgOvlvlNm(rvrItem.swStgOvlvl) }}</v-chip
                  >
                </span>
                </v-list-item-title>
                  </v-list-item-content>
                </template>
                <!-- 通常画面 -->
                <div v-if="rvrItem.tmDetailInfo && !pcPanelMode">
                  <!-- 通常水位 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmStg"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.stgDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 4, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(4, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title class="tm-nm"
                            >{{ getObsNm(subItem) }}
                            <v-chip
                              v-show="subItem.stgOvlvl"
                              class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                              :rw-info-color="setRwInfoColor(subItem.stgOvlvl)"
                              label
                              x-small
                              >{{ getStgOvlvlNm(subItem.stgOvlvl) }}</v-chip
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row no-gutters>
                              <v-col
                                v-if="subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(4, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="stgMode === '1' && subItem.dspFlg === 2"
                                class="col tm-rvr-item"
                                >{{ subItem.items[0].desc }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item">{{
                                subItem.items[stgMode].desc
                              }}</v-col>
                              <v-col
                                v-if="
                                  subItem.stgCcd == 190 ||
                                    subItem.stgCcd == null
                                "
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="subItem.stgCcd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="
                                  stgMode === '1' &&
                                    subItem.dspFlg === 2 &&
                                    subItem.items[0].val != null &&
                                    subItem.obsTime != null &&
                                    subItem.stgCcd < 130
                                "
                                class="col tm-rvr-item"
                                >{{ subItem.items[0].val
                                }}{{ subItem.items[0].unit }}</v-col
                              >
                              <v-col
                                v-else-if="
                                  subItem.items[stgMode].val != null &&
                                    subItem.obsTime != null &&
                                    subItem.stgCcd < 130
                                "
                                class="col tm-rvr-item"
                                >{{ subItem.items[stgMode].val
                                }}{{ subItem.items[stgMode].unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ text.noData
                                }}{{ subItem.items[stgMode].unit }}</v-col
                              >
                              <v-col class="tm-rvr-item">
                                <v-icon v-if="subItem.stgCcd >= 130"></v-icon>
                                <v-icon v-else-if="subItem.stg10mChgCcd >= 130"></v-icon>
                                <v-icon
                                  v-else-if="
                                    subItem.stg10mChg < 0 &&
                                      subItem.obsTime != null
                                  "
                                  class="icon-arrow-down"
                                  >arrow_downward</v-icon
                                >
                                <v-icon
                                  v-else-if="
                                    subItem.stg10mChg === 0 &&
                                      subItem.obsTime != null
                                  "
                                  class="icon-arrow-down"
                                  >arrow_forward</v-icon
                                >
                                <v-icon
                                  v-else-if="
                                    subItem.stg10mChg > 0 &&
                                      subItem.obsTime != null
                                  "
                                  class="icon-arrow-up"
                                  >arrow_upward</v-icon
                                >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-if="subItem.stgCcd >= 130"
                                    ></v-icon>
                                    <v-icon
                                      v-else-if="
                                        subItem.items[stgMode].qmFlg != null &&
                                          subItem.items[stgMode].qmFlg != '0' &&
                                          subItem.obsTime != null
                                      "
                                      v-on="on"
                                      class="icon-qmflg"
                                      >warning</v-icon
                                    >
                                  </template>
                                  <span>{{ text.abnormal }}</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 危機管理型水位 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmSwin"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.swstgDisp === true">
                      <v-list-item
                        @click="
                          clickObsList(subItem.swofcCd, 300, subItem.swobsCd)
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(300, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title class="tm-nm"
                            >{{ subItem.swobsNm }}
                            <v-chip
                              v-show="showOvlvlLabel(subItem.swstgOvlvl)"
                              class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                              :rw-info-color="
                                setRwInfoColor(subItem.swstgOvlvl)
                              "
                              label
                              x-small
                              >{{ getSwStgOvlvlNm(subItem.swstgOvlvl) }}</v-chip
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmRvIdx) in subItem.items"
                              :key="tmRvIdx"
                            >
                              <v-col
                                v-if="tmRvIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(300, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmRvIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">{{
                                data.desc
                              }}</v-col>
                              <v-col
                                v-if="
                                  data.val != null && subItem.obsTime != null
                                "
                                class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col class="tm-rvr-item">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      v-if="subItem.swstgCcd >= 130"
                                    ></v-icon>
                                    <v-icon
                                      v-if="
                                        data.stgQmflg != null &&
                                          data.stgQmflg != '0' &&
                                          subItem.obsTime != null
                                      "
                                      class="icon-qmflg"
                                      v-on="on"
                                      >warning</v-icon
                                    >
                                  </template>
                                  <span>{{ text.abnormal }}</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- CCTVカメラ -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmCctv"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.cctvDisp === true">
                      <v-list-item
                        @click="
                          clickCctvList(
                            subItem.ofcCd,
                            100,
                            subItem.scamId,
                            subItem.ownCd,
                            subItem.sysCamId
                          )
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(100, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.cctvNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 簡易カメラ -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmScam"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.cctvDisp === true">
                      <v-list-item
                        @click="
                          clickScamList(
                            200,
                            subItem.scamId,
                            subItem.ownCd,
                            subItem.sysCamId
                          )
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(200, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.scamNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- ダム諸量 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmDam"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.damDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 7, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(7, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmDamIdx) in subItem.items"
                              :key="tmDamIdx"
                            >
                              <v-col
                                v-if="tmDamIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(7, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmDamIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">
                                <span>{{ data.desc }}</span>
                              </v-col>
                              <v-col
                                v-if="data.ccd == 190"
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd > 130 || data.val == null"
                                class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 雨量 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmRain"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.rnDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 1, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(1, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmRnIdx) in subItem.items"
                              :key="tmRnIdx"
                            >
                              <v-col
                                v-if="tmRnIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(1, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmRnIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">
                                <span>{{ data.desc }}</span>
                              </v-col>
                              <v-col
                                v-if="data.ccd == 190"
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd > 130 || data.val == null"
                                class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 海岸 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmCoast"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.coastDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 12, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(12, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmCtIdx) in subItem.items"
                              :key="tmCtIdx"
                            >
                              <v-col
                                v-if="tmCtIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(12, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmCtIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">
                                <span>{{ data.desc }}</span>
                              </v-col>
                              <v-col
                                v-if="data.ccd == 190"
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd > 130 || data.val == null"
                                class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 積雪深 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmSnow"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.snwDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 3, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(3, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmSwIdx) in subItem.items"
                              :key="tmSwIdx"
                            >
                              <v-col
                                v-if="tmSwIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(3, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmSwIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">
                                <span>{{ data.desc }}</span>
                              </v-col>
                              <v-col
                                v-if="data.ccd == 190"
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd > 130 || data.val == null"
                                class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 水質 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.nmTmQwtr"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.qwtrDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 6, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(6, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row
                              no-gutters
                              v-for="(data, tmWtIdx) in subItem.items"
                              :key="tmWtIdx"
                            >
                              <v-col
                                v-if="tmWtIdx === 0 && subItem.obsTime != null"
                                class="col-4 tm-date"
                                >{{ getDispDate(6, subItem) }}</v-col
                              >
                              <v-col v-else class="col-4"></v-col>
                              <v-col
                                v-if="tmWtIdx === 0"
                                class="col tm-rvr-item"
                                >{{ data.desc }}</v-col
                              >
                              <v-col v-else class="col-4 tm-rvr-item">
                                <span>{{ data.desc }}</span>
                              </v-col>
                              <v-col
                                v-if="data.ccd == 190"
                                class="col tm-rvr-item"
                                >{{ text.missing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd == 140"
                                class="col tm-rvr-item"
                                >{{ text.closing }}</v-col
                              >
                              <v-col
                                v-else-if="data.ccd > 130 || data.val == null"
                                class="col tm-rvr-item"
                                >{{ text.noData }}{{ data.unit }}</v-col
                              >
                              <v-col v-else class="col tm-rvr-item"
                                >{{ data.val }}{{ data.unit }}</v-col
                              >
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                </div>
                <!-- 拡大画面 -->
                <div v-if="rvrItem.tmDetailInfo && pcPanelMode">
                  <!-- 通常水位 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgStg"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.stgDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 4, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(4, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title class="tm-nm"
                            >{{ getObsNm(subItem) }}
                            <v-chip
                              v-show="subItem.stgOvlvl"
                              class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                              :rw-info-color="setRwInfoColor(subItem.stgOvlvl)"
                              label
                              x-small
                              >{{ getStgOvlvlNm(subItem.stgOvlvl) }}</v-chip
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(4, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex md>
                                  <div
                                    v-if="
                                      stgMode === '1' && subItem.dspFlg === 2
                                    "
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ subItem.items[0].desc }}
                                  </div>
                                  <div
                                    v-else
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ subItem.items[stgMode].desc }}
                                  </div>
                                  <span
                                    v-if="
                                      subItem.stgCcd == 190 ||
                                        subItem.stgCcd == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="subItem.stgCcd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      stgMode === '1' &&
                                        subItem.dspFlg === 2 &&
                                        subItem.items[0].val != null &&
                                        subItem.obsTime != null &&
                                        subItem.stgCcd < 130
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ subItem.items[0].val
                                    }}{{ subItem.items[0].unit }}</span
                                  >
                                  <span
                                    v-else-if="
                                      subItem.items[stgMode].val != null &&
                                        subItem.obsTime != null &&
                                        subItem.stgCcd < 130
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ subItem.items[stgMode].val
                                    }}{{ subItem.items[stgMode].unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData
                                    }}{{ subItem.items[stgMode].unit }}</span
                                  >
                                  <v-icon v-if="subItem.stgCcd >= 130"></v-icon>
                                  <v-icon v-else-if="subItem.stg10mChgCcd >= 130"></v-icon>
                                  <v-icon
                                    v-else-if="
                                      subItem.stg10mChg < 0 &&
                                        subItem.obsTime != null
                                    "
                                    class="icon-arrow-down large_tm_icon"
                                    >arrow_downward</v-icon
                                  >
                                  <v-icon
                                    v-else-if="
                                      subItem.stg10mChg === 0 &&
                                        subItem.obsTime != null
                                    "
                                    class="icon-arrow-down large_tm_icon"
                                    >arrow_forward</v-icon
                                  >
                                  <v-icon
                                    v-else-if="
                                      subItem.stg10mChg > 0 &&
                                        subItem.obsTime != null
                                    "
                                    class="icon-arrow-up large_tm_icon"
                                    >arrow_upward</v-icon
                                  >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-icon
                                        v-if="
                                          subItem.items[stgMode].qmFlg !=
                                            null &&
                                            subItem.items[stgMode].qmFlg !=
                                              '0' &&
                                            subItem.obsTime != null
                                        "
                                        v-on="on"
                                        class="icon-qmflg large_tm_icon"
                                        >warning</v-icon
                                      >
                                    </template>
                                    <span>{{ text.abnormal }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 危機管理型水位 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgSwin"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.swstgDisp === true">
                      <v-list-item
                        @click="
                          clickObsList(subItem.swofcCd, 300, subItem.swobsCd)
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(300, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title class="tm-nm"
                            >{{ subItem.swobsNm }}
                            <v-chip
                              v-show="showOvlvlLabel(subItem.swstgOvlvl)"
                              class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                              :rw-info-color="
                                setRwInfoColor(subItem.swstgOvlvl)
                              "
                              label
                              x-small
                              >{{ getSwStgOvlvlNm(subItem.swstgOvlvl) }}</v-chip
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(300, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  md
                                  v-for="(data, tmSwstgIdx) in subItem.items"
                                  :key="tmSwstgIdx"
                                >
                                  <div
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="
                                      data.val != null &&
                                        subItem.obsTime != null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                  <span v-else class="tm-rvr-item tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-icon
                                        v-if="subItem.swstgCcd >= 130"
                                      ></v-icon>
                                      <v-icon
                                        v-else-if="
                                          data.stgQmflg != null &&
                                            data.stgQmflg != '0' &&
                                            subItem.obsTime != null
                                        "
                                        v-on="on"
                                        class="icon-qmflg large_tm_icon"
                                        >warning</v-icon
                                      >
                                    </template>
                                    <span>{{ text.abnormal }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- CCTVカメラ -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgCctv"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.cctvDisp === true">
                      <v-list-item
                        @click="
                          clickCctvList(
                            subItem.ofcCd,
                            100,
                            subItem.scamId,
                            subItem.ownCd,
                            subItem.sysCamId
                          )
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(100, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.cctvNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 簡易カメラ -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgScam"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.cctvDisp === true">
                      <v-list-item
                        @click="
                          clickScamList(
                            200,
                            subItem.scamId,
                            subItem.ownCd,
                            subItem.sysCamId
                          )
                        "
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(200, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.scamNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- ダム諸量 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgDam"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.damDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 7, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(7, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(7, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmDamFstIndex) in subItem.firstItems"
                                  :key="tmDamFstIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                            <v-row>
                              <div class="large_date"></div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmDamFstIndex) in subItem.secondItems"
                                  :key="tmDamFstIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 雨量 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgRain"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.rnDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 1, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(1, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(1, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data, tmRnIdx) in subItem.items"
                                  :key="tmRnIdx"
                                >
                                  <div
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 海岸 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgCoast"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.coastDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 12, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(12, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(12, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmCtFstIndex) in subItem.firstItems"
                                  :key="tmCtFstIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_five_rows_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                            <v-row>
                              <div class="large_date"></div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmCtScIndex) in subItem.secondItems"
                                  :key="tmCtScIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_five_rows_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 積雪深 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgSnow"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.snwDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 3, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(3, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(3, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data, tmSwIdx) in subItem.items"
                                  :key="tmSwIdx"
                                >
                                  <div
                                    class="tm-rvr-item large_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                  <!-- 水質 -->
                  <div
                    v-for="subItem in rvrItem.tmDetailInfo.lgTmQwtr"
                    :key="subItem.city"
                  >
                    <div v-if="selectObsDisp.qwtrDisp === true">
                      <v-list-item
                        @click="clickObsList(subItem.ofcCd, 6, subItem.obsCd)"
                      >
                        <v-list-item-action>
                          <img
                            class="tm-list-icon-size"
                            :src="getIcon(6, subItem)"
                          />
                        </v-list-item-action>
                        <v-list-item-content class="tm-pc-list-content-inf">
                          <v-list-item-title
                            class="tm-nm"
                            v-text="subItem.obsNm"
                          ></v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row>
                              <div class="large_date">
                                <v-col class="large_date_item">
                                  <div
                                    v-if="subItem.obsTime != null"
                                    class="tm-date"
                                  >
                                    {{ getDispDate(6, subItem) }}
                                  </div>
                                </v-col>
                              </div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmWtFstIndex) in subItem.firstItems"
                                  :key="tmWtFstIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_five_rows_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                            <v-row>
                              <div class="large_date"></div>
                              <v-layout row justify-center>
                                <v-flex
                                  v-for="(data,
                                  tmWtScIndex) in subItem.secondItems"
                                  :key="tmWtScIndex"
                                >
                                  <div
                                    class="tm-rvr-item large_five_rows_tm_desc pl-8 pr-2"
                                  >
                                    {{ data.desc }}
                                  </div>
                                  <span
                                    v-if="data.ccd == 190"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.missing }}</span
                                  >
                                  <span
                                    v-else-if="data.ccd == 140"
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.closing }}</span
                                  >
                                  <span
                                    v-else-if="
                                      data.ccd > 130 || data.val == null
                                    "
                                    class="tm-rvr-item large_tm_value"
                                    >{{ text.noData }}{{ data.unit }}</span
                                  >
                                  <span
                                    v-else
                                    class="tm-rvr-item large_tm_value"
                                    >{{ data.val }}{{ data.unit }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                </div>
              </v-list-group>
            </v-list>
          </v-list-group>
        </v-list>
      </div>
      <v-list
        v-if="
          isEmpty(rsysList) &&
            this.reqParam.townsAcqTime == this.tmListDatasParam.rsysAcqTime
        "
        class="tm-no-regist"
        >{{ this.$store.state.app.config.messageConfig.tmNoRegist }}</v-list
      >
    </v-col>
  </v-card>
</template>

<script>
import mixin from "./../../lib/mixin.js";
import util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
import TmList from "./../../lib/tmList.js";
export default {
  name: "tm-rsys-list",
  mixins: [mixin],
  data() {
    return {
      prefs: "",
      towns: "",
      text: {
        noData: "--",
        missing: "欠測",
        closing: "閉局",
        abnormal: "異常のおそれあり",
      },
      reload: true,
    };
  },
  created: function() {},
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[tmlist]mut - getTmRsysList(" + this.reqParam.towns + ")");
    this.getTmRsysList(true);
    // 全開閉完了フラグ初期化
    this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);
  },
  props: {
    // 親コンポーネントの観測所表示設定
    selectObsDispPt: Object,
  },
  computed: {
    /**
     * 表示範囲のパラメータ
     */
    tmListDatasParam: {
      get() {
        return this.$store.state.Telemeter.tmDatasParam;
      },
    },
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** 水系河川情報表示 */
    showRsys: {
      get() {
        return (
          this.$store.state.map.zoom <
          this.$store.state.map.mapConfig.zoomTmListRsys
        );
      },
    },
    /** 水系河川の情報一覧 */
    rsysList: {
      get() {
        return this.$store.state.Telemeter.rsysTmList;
      },
    },
    /** 表示水系河川の情報一覧 */
    dispRsysTmList: {
      get() {
        return this.$store.state.Telemeter.dispRsysTmList;
      },
    },
    /** 観測所表示設定 */
    selectObsDisp: {
      get() {
        return this.$store.state.Telemeter.selectObsDisp[0];
      },
    },
    /** 観測所一覧全開閉ボタン表示 */
    showAllOpenBtn: {
      get() {
        return (
          this.$store.state.map.mapConfig.zoomTmListShowFullOpenBtnByRsys <=
          this.$store.state.map.zoom
        );
      },
    },
    /** 観測所一覧水系別全開閉フラグ */
    rysyFullOpenFlg: {
      get() {
        return this.$store.state.Telemeter.tmlistRsysFullOpenFlg;
      },
    },
    /** 観測所一覧水系別全開閉準備フラグ */
    rsysFullOpenReadyFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenReadyFlg;
      },
    },
    /** 観測所一覧水系別全開閉データ取得完了フラグ */
    rsysFullOpenEndFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenEndFlg;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          // 観測日時
          appTime: this.$store.state.app.appTime,
          // 観測日時(ファイル取得用)
          appTimeRound: this.$store.state.app.appTimeRound,
          // 市町村リスト取得日時
          townsAcqTime: this.$store.state.map.townsAcqTime,
          // 表示市町村
          towns: this.$store.state.map.towns,
          // 表示都道府県
          prefs: this.$store.state.map.prefs,
          // 観測所表示設定
          selectObsDisp: this.$store.state.Telemeter.selectObsDisp[0],
          // 都道府県 市町村種別
          prefTownType: this.$store.state.map.prefTownType,
        };
      },
    },
  },
  methods: {
    /**
     * 水系情報一覧を取得
     * @param API実行フラグ
     *   true： API実行
     *   false: API実行しない
     */
    getTmRsysList(apiFlg) {
      if (!this.showRsys) {
        this.$log.debug("[tmlist] getRsysInfo() param:" + apiFlg);
        // アクセスログ出力
        // 画面表示中のみログ出力
        if (this.$store.state.app.content == "TmList") {
          PageLog.log({
            page_log: "list_river",
            lat: this.$store.state.map.center[0],
            lon: this.$store.state.map.center[1],
            zm: this.$store.state.map.zoom,
            device_sb: this.$store.state.app.mode,
            fc_flg: this.$store.getters["app/isFldCtl"],
          });
        }
        if (this.rysyFullOpenFlg) {
          // 全展開準備フラグtrue
          this.$store.commit("Telemeter/setTmListRsysFullOpenReadyFlg", true);
        }

        // 水系の情報一覧を取得
        setTimeout(() => {
          this.$store.dispatch("Telemeter/getRsysInfo", {
            prefs: this.reqParam.prefs,
            towns: this.reqParam.towns,
            selectObsDisp: this.reqParam.selectObsDisp,
            apiFlg: apiFlg,
            fullOpenFlg: this.rysyFullOpenFlg,
            appTime: this.reqParam.appTime,
            appTimeRound: this.reqParam.appTimeRound,
            townsAcqTime: this.reqParam.townsAcqTime,
            prefTownType: this.reqParam.prefTownType,
            dispRsysList: this.dispRsysTmList,
          });
        }, 500);
        this.prefs = this.reqParam.prefs;
        this.towns = this.reqParam.towns;
      }
    },
    /**
     * 観測所情報を取得
     */
    getTmRvrListDatas(rsysCd, rvrCd) {
      if (this.containsObsInfo(rvrCd)) {
        // 観測所情報を取得
        // アクセスログ出力
        PageLog.log({
          page_log: "list_river",
          lat: this.$store.state.map.center[0],
          lon: this.$store.state.map.center[1],
          zm: this.$store.state.map.zoom,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
        this.$log.debug("[tmlist] - getTmDatasByRsys()");
        setTimeout(() => {
          this.$store.dispatch("Telemeter/getTmDatasByRsys", {
            rsysCd: rsysCd,
            rvrCd: rvrCd,
            appTime: this.reqParam.appTime,
            appTimeRound: this.reqParam.appTimeRound,
          });
        }, 500);
      }
    },
    /**
     * 観測所情報が取得済みか判定
     */
    containsObsInfo(rvrCd) {
      var getFlg = false;
      for (var i = 0; i < this.rsysList.length; i++) {
        for (var j = 0; j < this.rsysList[i].rvrInfo.length; j++) {
          if (
            this.rsysList[i].rvrInfo[j].rvrCd == rvrCd &&
            !("tmDetailInfo" in this.rsysList[i].rvrInfo[j])
          ) {
            getFlg = true;
          }
        }
      }
      return getFlg;
    },
    /** 個別観測所画面へ遷移 */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[tmList]act - clickObsList(" +
          "," +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          ")"
      );
      this.$log.debug("[tmList]act - pchangePanelMode(false)");
      // パネル拡大モードOFF
      // this.$store.commit("app/setPcPanelMode", false);
      if (itmkndCd === 300) {
        // 選択中危機管理水位情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: ofcCd,
          itmkndCd: itmkndCd,
          swobsCd: obsCd,
        });
        // 画面遷移
        this.routerPushTmSw("/pc/tm");
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: ofcCd,
          itmkndCd: itmkndCd,
          obsCd: obsCd,
        });
        // 画面遷移
        this.routerPushTm("/pc/tm");
      }
    },
    /** CCTV画面へ遷移 */
    clickCctvList(ofcCd, itmkndCd, scamId, ownCd, sysCamId) {
      this.$log.debug(
        "[tmList]act - clickCctvList(" +
          "," +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          scamId +
          "," +
          ownCd +
          "," +
          sysCamId +
          ")"
      );
      this.$log.debug("[tmList]act - pchangePanelMode(false)");
      // パネル拡大モードOFF
      // this.$store.commit("app/setPcPanelMode", false);
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParamCctv", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // 画面遷移
      this.routerPushTmScam("/pc/tm");
    },
    /** 簡易カメラ画面へ遷移 */
    clickScamList(itmkndCd, scamId, ownCd, sysCamId) {
      this.$log.debug(
        "[rp/TmList] clickScamList(" +
          itmkndCd +
          "," +
          scamId +
          "," +
          ownCd +
          "," +
          sysCamId +
          ")"
      );
      // パネル拡大モードOFF
      // this.$store.commit("app/setPcPanelMode", false);
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParamScam", {
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // 画面遷移
      this.routerPushTmScam("/pc/tm");
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(itmkndCd, obsItem) {
      this.$log.debug("[tmList] getDispDate(" + obsItem.obsTime + ")");
      if (TmList.checkNotCollected(itmkndCd, obsItem)) {
        // 未収集
        return this.text.noData;
      }
      return util.formatDate24(obsItem.obsTime, "YYYY/MM/DD HH:mm");
    },
    /**
     * リストは空かどうかの判定
     */
    isEmpty(list) {
      if (list == null) {
        return true;
      } else if (Object.keys(list).length == 0) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 観測所アイコンの取得
     */
    getIcon(tm, item) {
      return TmList.getIcon(tm, item, this.isFldCtl);
    },
    /**
     * 超過観測所 着色
     */
    setRwInfoColor(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "occurrence";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "danger";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "refuge";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "warn";
      }
      return "other";
    },
    /**
     * 超過基準水位名を表示するか
     */
    showOvlvlLabel(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    /**
     * 危機管理水位の超過基準水位名を表示するか
     */
    showSwStgOvlvlLabel(stgOvlvl) {
      if (30 == stgOvlvl || stgOvlvl == 80 || stgOvlvl == 90) {
        return true;
      }
      return false;
    },
    /**
     * 通常水位：超過基準水位名の取得
     */
    getStgOvlvlNm(stgOvlvl) {
      return TmList.getStgOvlvlNm(stgOvlvl);
    },
    /**
     * 危機管理水位：超過基準水位名の取得
     */
    getSwStgOvlvlNm(stgOvlvl) {
      return TmList.getSwStgOvlvlNm(stgOvlvl);
    },
    /**
     * 観測所名の取得
     */
    getObsNm(item) {
      if (
        item.fldfrFlg === 1 ||
        item.evstgFlg === 1 ||
        (this.isFldCtl && item.fldctlFlg === 1)
      ) {
        // 洪水予報観測所フラグ、もしくは水位周知基準観測所フラグが有効
        // または、水防団モードで、且つ水防警報観測所フラグが有効の時
        return item.obsNm[1];
      }
      return item.obsNm[0];
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      // 表示時刻または市町村情報が変更された場合にAPIを取得
      if (
        this.reqParam.appTimeRound != this.tmListDatasParam.dispTime ||
        JSON.stringify(this.reqParam.prefs) != JSON.stringify(this.prefs) ||
        JSON.stringify(this.reqParam.towns) != JSON.stringify(this.towns)
      ) {
        this.$log.debug(
          "[tmList] req.appTimeRound !== prm.dispTime:" +
            (this.reqParam.appTimeRound != this.tmListDatasParam.dispTime)
        );
        this.$log.debug(
          "[tmList] req.prefs !== this.prefs:" +
            (JSON.stringify(this.reqParam.prefs) != JSON.stringify(this.prefs))
        );
        this.$log.debug(
          "[tmList] req.towns !== this.towns:" +
            (JSON.stringify(this.reqParam.towns) != JSON.stringify(this.towns))
        );
        // 全開閉完了フラグ初期化
        this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);

        // API実行フラグON
        this.getTmRsysList(true);
        this.reload = false;
        this.$nextTick(() => (this.reload = true));
      }
    },
    /**
     * 全開閉ボタン押下時
     */
    rysyFullOpenFlg() {
      // 全開フラグが押下され、全開ボタン表示範囲だった場合APIを取得
      if (this.rysyFullOpenFlg && this.showAllOpenBtn) {
        this.$log.debug(
          "[tmList] rysyFullOpenFlg == true:" + this.rysyFullOpenFlg
        );
        // 全開閉完了フラグ初期化
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);
        // API実行フラグtrue、全開閉フラグtrue
        this.getTmRsysList(true);
      }
    },
    // 観測所表示設定が変更された場合にAPIを取得
    selectObsDispPt: {
      handler() {
        this.$log.debug("[tmList] selectObsDispPt is changed");
        // 全開閉完了フラグ初期化
        this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);

        // API実行フラグOFF
        this.getTmRsysList(false);
        this.reload = false;
        this.$nextTick(() => (this.reload = true));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tmList-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.large_date {
  width: 200px;
  height: 22px;

  .large_date_item {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.large_tm_desc {
  display: table-cell;
  width: 100px;
}
.large_five_rows_tm_desc {
  display: table-cell;
  width: 150px;
}
.large_tm_value {
  display: table-cell;
  width: 80px;
}
.large_tm_icon {
  padding: 0;
  display: table-cell;
  width: 30px;
}
.tm-no-show {
  font-size: 1rem;
}
</style>
